import { useEffect, useRef } from 'react';

export function useMouseParallax(rootRef) {
  const rafRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    if (window.innerWidth <= 900) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const glow = root.querySelector('.hero-glow');
    const grid = root.querySelector('.hero-grid-bg');

    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const onMove = (e) => {
      targetX = (e.clientX / window.innerWidth - 0.5) * 2;
      targetY = (e.clientY / window.innerHeight - 0.5) * 2;
    };

    const tick = () => {
      currentX += (targetX - currentX) * 0.06;
      currentY += (targetY - currentY) * 0.06;

      const t = performance.now() * 0.0001;

      if (glow) {
        const gx = currentX * 20 + Math.sin(t * 1.4) * 5;
        const gy = currentY * 14 + Math.cos(t * 1.8) * 4;
        glow.style.transform = `translate(${gx}px, ${gy}px)`;
      }

      if (grid) {
        const ix = Math.sin(t * 2.2) * 3;
        const iy = Math.cos(t * 3.1) * 2;
        grid.style.transform = `translate(${currentX * 6 + ix}px, ${currentY * 6 + iy}px)`;
      }

      rafRef.current = requestAnimationFrame(tick);
    };

    window.addEventListener('mousemove', onMove, { passive: true });
    rafRef.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
